// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"94eee612","344":"5647a2a8","375":"47389daa"}[chunkId] + ".chunk.js";
};